// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-table-row > .custom-table-row {
  padding: 16px 24px;
  /* Modify the padding values as needed */
}

.sidebar.admin-sidebar {
  border-right: 0px;
  width: 300px;
  margin-top: 90px;
}
.sidebar.admin-sidebar .sidebar-wrapper {
  width: 300px;
}
.sidebar.admin-sidebar .sidebar-user-details {
  position: relative;
  z-index: 4;
  padding: 30px 25px 0;
  display: flex;
  align-items: center;
  column-gap: 15px;
}
.sidebar.admin-sidebar .sidebar-user-details .user-img-wrap {
  width: 65px;
  height: 65px;
  display: inline-flex;
}
.sidebar.admin-sidebar .sidebar-user-details .user-img-wrap img {
  width: 100%;
}
.sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user {
  display: flex;
  flex-direction: column;
  width: calc(100% - 80px);
  row-gap: 4px;
}
.sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user .logged-user-name {
  color: #fff;
  font-size: 20px;
  line-height: 1;
  margin: 0px;
}
.sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user .logged-user-pack {
  color: rgb(164, 164, 164);
  font-size: 16px;
  line-height: 23px;
}
.sidebar.admin-sidebar .sidebar-wrapper .nav {
  margin-top: 30px;
}
.sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink {
  font-size: 18px;
  line-height: 30px;
  color: #fff;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  padding: 12px 20px;
  margin: 0px;
  font-weight: 500;
  opacity: 1;
}
.sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink i {
  margin-right: 8px;
  width: 30px;
  height: 30px;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #fff;
}
.sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink.active {
  background-color: rgb(255, 255, 255);
  font-weight: 600;
  color: rgb(2, 58, 40);
}
.sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink.active i {
  color: rgb(2, 58, 40);
}
.sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink.active:before {
  left: 0px;
  width: 6px;
  height: calc(100% - 20px);
  background-color: rgb(2, 58, 40);
  border: 0px;
  top: 50%;
  transform: translateY(-50%);
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink.active:after {
  display: none;
}
.sidebar.admin-sidebar .sidebar-wrapper .nav li:not(:last-child) {
  margin-bottom: 10px;
}
@media (max-width: 1600px) {
  .sidebar.admin-sidebar {
    margin-top: 72px;
    width: 280px;
  }
  .sidebar.admin-sidebar .sidebar-user-details {
    padding: 25px 20px 0;
    column-gap: 10px;
  }
  .sidebar.admin-sidebar .sidebar-user-details .user-img-wrap {
    width: 50px;
    height: 50px;
  }
  .sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user {
    width: calc(100% - 60px);
  }
  .sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user .logged-user-name {
    font-size: 18px;
  }
  .sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user .logged-user-pack {
    font-size: 15px;
    line-height: 20px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper {
    width: 280px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav {
    margin-top: 20px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink {
    font-size: 17px;
    line-height: 26px;
    padding: 10px 15px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink i {
    margin-right: 6px;
    width: 26px;
    height: 26px;
    font-size: 18px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink.active:before {
    height: calc(100% - 18px);
    width: 5px;
  }
}
@media (max-width: 1399px) {
  .sidebar.admin-sidebar {
    margin-top: 55px;
    width: 240px;
  }
  .sidebar.admin-sidebar .sidebar-user-details {
    padding: 20px 15px 0;
    column-gap: 8px;
  }
  .sidebar.admin-sidebar .sidebar-user-details .user-img-wrap {
    width: 40px;
    height: 40px;
  }
  .sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user {
    width: calc(100% - 45px);
    row-gap: 2px;
  }
  .sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user .logged-user-name {
    font-size: 16px;
  }
  .sidebar.admin-sidebar .sidebar-user-details .sidebar-logged-user .logged-user-pack {
    font-size: 13px;
    line-height: 18px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper {
    width: 240px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav {
    margin-top: 15px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink {
    font-size: 15px;
    line-height: 24px;
    padding: 8px 10px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink i {
    margin-right: 4px;
    width: 24px;
    height: 24px;
    font-size: 16px;
  }
  .sidebar.admin-sidebar .sidebar-wrapper .nav li .nav-NavLink.active:before {
    height: calc(100% - 14px);
  }
}

.main-panel.admin-main-body {
  background-color: rgb(250, 250, 250);
  width: calc(100% - 300px);
  height: 100vh;
  overflow: hidden;
}
.main-panel.admin-main-body .admin-panel-content {
  height: calc(100vh - 0px);
}
.main-panel.admin-main-body .admin-panel-content .content {
  margin-top: 140px;
  padding: 0 40px 30px;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards {
  box-shadow: none;
  border-radius: 8px;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-light-yellow {
  background-color: rgba(255, 167, 85, 0.21);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-light-purple {
  background-color: rgba(81, 40, 167, 0.21);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-light-cyan {
  background-color: rgba(112, 159, 186, 0.21);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-light-pink {
  background-color: rgba(228, 186, 243, 0.21);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-light-green {
  background-color: rgba(11, 138, 0, 0.12);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-dark-green {
  background-color: rgb(216, 238, 174);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-green {
  background-color: rgb(191, 221, 211);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-light-red {
  background-color: rgba(255, 77, 79, 0.21);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards.bg-light-blue {
  background-color: rgba(22, 119, 255, 0.21);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body {
  padding: 20px 30px;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap {
  display: flex;
  align-items: center;
  column-gap: 12px;
  margin-bottom: 12px;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap .card-title {
  font-size: 21px;
  line-height: 28px;
  font-weight: 500;
  color: rgb(52, 52, 52);
  margin: 0px;
  text-transform: capitalize;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap .card-badge {
  padding: 4px 5px;
  border-radius: 66px;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  column-gap: 4px;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap .card-badge.green-badge {
  background-color: rgba(35, 193, 10, 0.15);
  color: rgb(11, 138, 0);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap .card-badge.red-badge {
  background-color: rgba(193, 10, 10, 0.15);
  color: rgb(199, 16, 38);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 5px;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details .total-figure {
  margin: 0px;
  font-weight: 600;
  font-size: 32px;
  line-height: 44px;
  color: rgb(35, 35, 35);
  margin-bottom: 0px;
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details .card-label {
  font-size: 16px;
  line-height: 24px;
  color: rgb(148, 148, 148);
}
.main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details .card-click-link {
  margin-left: auto;
  font-size: 13px;
  line-height: 18px;
  font-weight: 600;
}
@media (max-width: 1600px) {
  .main-panel.admin-main-body {
    width: calc(100% - 280px);
  }
  .main-panel.admin-main-body .admin-panel-content .content {
    margin-top: 120px;
    padding: 0 30px 25px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body {
    padding: 15px 25px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap {
    margin-bottom: 10px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap .card-title {
    font-size: 18px;
    line-height: 26px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details .total-figure {
    font-size: 28px;
    line-height: 40px;
  }
}
@media (max-width: 1399px) {
  .main-panel.admin-main-body {
    width: calc(100% - 240px);
  }
  .main-panel.admin-main-body .admin-panel-content .content {
    margin-top: 85px;
    padding: 0 25px 20px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body {
    padding: 10px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap {
    margin-bottom: 6px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-head-wrap .card-title {
    font-size: 16px;
    line-height: 24px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details {
    gap: 2px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details .total-figure {
    font-size: 20px;
    line-height: 28px;
  }
  .main-panel.admin-main-body .admin-panel-content .content .dashboard-cards .card-body .card-foot-details .card-click-link {
    font-size: 12px;
    line-height: 16px;
  }
}

.ant-table-wrapper {
  border: 1px solid rgb(203, 203, 203);
  border-radius: 14px;
  color: rgb(2, 58, 40);
  padding: 15px;
  background-color: #fff;
  height: 100%;
}
.ant-table-wrapper .ant-table {
  border-start-start-radius: 14px;
  border-start-end-radius: 14px;
}
.ant-table-wrapper .ant-table .ant-table-container table tr th,
.ant-table-wrapper .ant-table .ant-table-container table tr td {
  color: rgb(2, 58, 40);
  font-family: "Manrope", "Helvetica Neue", Arial, sans-serif;
  border-bottom: 1px solid rgb(239, 239, 239);
}
.ant-table-wrapper .ant-table .ant-table-container table tr th {
  padding: 12px 8px;
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  white-space: nowrap;
}
.ant-table-wrapper .ant-table .ant-table-container table tr th:before {
  display: none;
}
.ant-table-wrapper .ant-table .ant-table-container table tr td {
  padding: 10px 8px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
}
.ant-table-wrapper .ant-table .ant-table-container table tr td h6 {
  font-weight: 400;
  text-transform: capitalize;
  margin: 0 0 7px 0;
  width: calc(100% - 55px);
}
.ant-table-wrapper .ant-table .ant-table-container table tr td h6.request-name {
  font-weight: 600;
  text-transform: capitalize;
  font-size: 16px;
}
.ant-table-wrapper .ant-table .ant-table-container table tr td p {
  margin: 0px;
  line-height: 1;
}
.ant-table-wrapper .ant-table .ant-table-container table tr td .cmn-user-detail {
  display: flex;
  align-items: center;
  column-gap: 20px;
}
.ant-table-wrapper .ant-table .ant-table-container table .ant-table-thead tr th {
  background-color: transparent;
}
.ant-table-wrapper .ant-table .ant-table-container table .ant-table-thead tr th:first-child {
  border-start-start-radius: 14px;
}
.ant-table-wrapper .ant-table .ant-table-container table .ant-table-thead tr th:last-child {
  border-start-end-radius: 14px;
}
.ant-table-wrapper .ant-table .ant-table-container table .ant-table-tbody .ant-table-placeholder .ant-table-cell {
  border-bottom: 0px;
}
.ant-table-wrapper .ant-table.ant-table-fixed-header .ant-table-container table tr th:nth-last-child(2) {
  text-align: right;
}
.ant-table-wrapper .ant-table.ant-table-fixed-header .ant-table-container table tr td:last-child {
  text-align: right;
}
.ant-table-wrapper.ltd-column-table .ant-table .ant-table-container table tr th:last-child {
  text-align: right;
}
.ant-table-wrapper .ant-table-empty .ant-table-tbody .ant-table-placeholder {
  width: 100%;
}
.ant-table-wrapper .ant-table-empty .ant-table-tbody .ant-table-placeholder td {
  padding: 0px;
}
.ant-table-wrapper.requested-shifts .ant-table .ant-table-container table .ant-table-thead tr th {
  background-color: rgba(228, 186, 243, 0.21);
}
.ant-table-wrapper.accepted-shifts .ant-table .ant-table-container table .ant-table-thead tr th {
  background-color: rgba(11, 138, 0, 0.12);
}
.ant-table-wrapper.declined-shifts .ant-table .ant-table-container table .ant-table-thead tr th {
  background-color: rgba(255, 77, 79, 0.21);
}
@media (max-width: 1600px) {
  .ant-table-wrapper {
    padding: 10px;
  }
  .ant-table-wrapper .ant-table .ant-table-container table tr td h6.request-name {
    font-size: 14px;
  }
}
@media (max-width: 1399px) {
  .ant-table-wrapper .ant-table .ant-table-container table tr th {
    padding: 10px 8px;
    font-size: 14px;
    line-height: 22px;
  }
  .ant-table-wrapper .ant-table .ant-table-container table tr td {
    font-size: 13px;
    line-height: 20px;
  }
  .ant-table-wrapper .ant-table .ant-table-container table tr td h6.request-name {
    font-size: 13px;
  }
}

.fields-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.tbl-user-details {
  display: flex;
  align-items: center;
  column-gap: 15px;
  overflow: hidden;
}
.tbl-user-details * {
  flex-shrink: 1;
  flex-grow: 1;
  white-space: nowrap;
}
.tbl-user-details .ant-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  flex-shrink: 0;
  flex-grow: 0;
}
.tbl-user-details .ant-avatar img {
  border-radius: 50%;
}
.tbl-user-details:hover {
  overflow: visible;
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, 0.6);
}
.tbl-user-details:hover * {
  background: rgba(255, 255, 255, 0.6);
}
@media (max-width: 1600px) {
  .tbl-user-details .ant-avatar {
    width: 36px;
    height: 36px;
  }
}
@media (max-width: 1399px) {
  .tbl-user-details .ant-avatar {
    width: 32px;
    height: 32px;
  }
}

.action-btn {
  border: 0px;
  padding: 0;
  border-radius: 50%;
  box-shadow: none;
  background-color: transparent;
}
.action-btn.action-approve-user {
  width: auto;
  padding: 6px 10px;
  border-radius: 30px;
  background-color: rgb(52, 152, 219);
  color: #fff;
}
.action-btn.action-approve-user:hover {
  background-color: rgba(52, 152, 219, 0.15) !important;
  color: inherit !important;
}

.fas {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 13px;
}
.fas.fa-edit, .fas.fa-eye {
  background-color: rgba(35, 193, 10, 0.15);
  color: rgb(11, 138, 0);
}
.fas.fa-sign-in-alt {
  background-color: rgba(52, 152, 219, 0.15);
  color: rgb(52, 152, 219);
}
.fas.fa-trash-alt {
  background-color: rgba(193, 10, 10, 0.15);
  color: rgb(199, 16, 38) !important;
}
.fas.fa-check {
  background-color: rgb(2, 58, 40);
  color: #fff;
}
.fas.fa-times {
  background-color: rgba(193, 10, 10, 0.15);
  color: rgb(199, 16, 38);
}
.fas:hover {
  opacity: 0.7;
}
@media (max-width: 1600px) {
  .fas {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
}
@media (max-width: 1399px) {
  .fas {
    width: 22px;
    height: 22px;
    font-size: 10px;
  }
}

.antd-tabs-wrapper {
  font-family: "Manrope", "Helvetica Neue", Arial, sans-serif;
}
.antd-tabs-wrapper .ant-tabs-nav {
  margin-bottom: 40px;
}
.antd-tabs-wrapper .ant-tabs-nav:before {
  display: none;
}
.antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
  column-gap: 10px;
}
.antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
  padding: 0px;
  border: 0px;
  font-size: 20px;
  line-height: 28px;
  color: #99A7A3;
  background-color: transparent;
  border-radius: 60px;
}
.antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab + .ant-tabs-tab {
  margin: 0px;
}
.antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab .ant-tabs-tab-btn {
  padding: 10px 18px;
  font-weight: 600;
}
.antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab .ant-tabs-tab-btn:focus {
  color: #99A7A3;
}
.antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab.ant-tabs-tab-active {
  background-color: #023A28;
}
.antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #FFFFFF;
}
@media (max-width: 1600px) {
  .antd-tabs-wrapper .ant-tabs-nav {
    margin-bottom: 30px;
  }
  .antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
    font-size: 18px;
    line-height: 26px;
  }
  .antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab .ant-tabs-tab-btn {
    padding: 8px 14px;
  }
}
@media (max-width: 1399px) {
  .antd-tabs-wrapper .ant-tabs-nav {
    margin-bottom: 20px;
  }
  .antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
    font-size: 16px;
    line-height: 24px;
  }
  .antd-tabs-wrapper .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab .ant-tabs-tab-btn {
    padding: 6px 14px;
  }
}

.ant-popover-content {
  font-family: "Manrope", "Helvetica Neue", Arial, sans-serif;
}
.ant-popover-content .ant-popover-inner-content .ant-popconfirm-buttons .ant-btn-default {
  border-color: rgb(199, 16, 38) !important;
  color: rgb(199, 16, 38) !important;
}
.ant-popover-content .ant-popover-inner-content .ant-popconfirm-buttons .ant-btn-primary {
  background-color: rgb(2, 58, 40);
}

.card .card-sub-title {
  color: rgb(2, 58, 40);
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
}
.card .input-value[disabled] {
  background-color: rgba(112, 112, 112, 0.15);
  color: rgb(112, 112, 112);
  border-color: rgba(112, 112, 112, 0.5);
}
.card .static-value {
  background-color: rgba(112, 112, 112, 0.15);
  color: rgb(112, 112, 112);
  border: 1px solid rgba(112, 112, 112, 0.5);
  width: 100%;
  display: flex;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  line-height: normal;
}
.card .form-group {
  color: rgb(112, 112, 112);
}
.card .card-sec .card-sec-title {
  color: rgb(2, 58, 40);
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
}

.page-main-title {
  font-size: 28px;
  line-height: 36px;
  font-family: "Manrope", "Helvetica Neue", Arial, sans-serif;
  color: rgb(2, 58, 40);
  font-weight: 600;
  margin-bottom: 20px;
}
@media (max-width: 1600px) {
  .page-main-title {
    font-size: 26px;
    line-height: 32px;
    margin-bottom: 15px;
  }
}
@media (max-width: 1399px) {
  .page-main-title {
    font-size: 24px;
    line-height: 30px;
    margin-bottom: 10px;
  }
}

.footer-btn-wrap {
  margin-top: 30px;
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.common-footer-btn.ant-btn {
  padding: 4px 12px;
  font-size: 16px;
  line-height: 24px;
  min-height: 40px;
  min-width: 110px;
}
@media (max-width: 1600px) {
  .common-footer-btn {
    min-height: 36px;
    min-width: 100px;
  }
}
@media (max-width: 1399px) {
  .common-footer-btn {
    min-height: 32px;
    min-width: 90px;
  }
}

.ant-modal-footer,
.ant-btn {
  font-family: "Manrope", "Helvetica Neue", Arial, sans-serif;
}
.ant-modal-footer .ant-btn-default, .ant-modal-footer.cancel-btn-wrap,
.ant-btn .ant-btn-default,
.ant-btn.cancel-btn-wrap {
  border-color: rgb(199, 16, 38);
  color: rgb(199, 16, 38);
}
.ant-modal-footer .ant-btn-default:hover, .ant-modal-footer .ant-btn-default:focus, .ant-modal-footer.cancel-btn-wrap:hover, .ant-modal-footer.cancel-btn-wrap:focus,
.ant-btn .ant-btn-default:hover,
.ant-btn .ant-btn-default:focus,
.ant-btn.cancel-btn-wrap:hover,
.ant-btn.cancel-btn-wrap:focus {
  border-color: rgb(199, 16, 38) !important;
  background-color: rgb(199, 16, 38) !important;
  color: #fff !important;
}
.ant-modal-footer .ant-btn-primary, .ant-modal-footer.save-btn-wrap,
.ant-btn .ant-btn-primary,
.ant-btn.save-btn-wrap {
  background-color: rgb(2, 58, 40);
  color: #fff;
  border-color: rgb(2, 58, 40);
}
.ant-modal-footer .ant-btn-primary:hover, .ant-modal-footer .ant-btn-primary:focus, .ant-modal-footer.save-btn-wrap:hover, .ant-modal-footer.save-btn-wrap:focus,
.ant-btn .ant-btn-primary:hover,
.ant-btn .ant-btn-primary:focus,
.ant-btn.save-btn-wrap:hover,
.ant-btn.save-btn-wrap:focus {
  border-color: rgb(2, 58, 40) !important;
  background-color: #fff !important;
  color: rgb(2, 58, 40) !important;
}
@media (max-width: 1600px) {
  .ant-modal-footer,
  .ant-btn {
    font-size: 15px;
    line-height: 22px;
  }
}
@media (max-width: 1399px) {
  .ant-modal-footer,
  .ant-btn {
    font-size: 14px;
    line-height: 20px;
  }
}

.page-header-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-header-wrap .page-main-title {
  margin-bottom: 0px;
}

.header-btn-wrap {
  border: 1px solid rgb(203, 203, 203);
  color: rgb(2, 58, 40);
  font-size: 18px;
  line-height: 26px;
  padding: 8px 14px;
  border-radius: 30px;
  background-color: #fff;
  min-width: 140px;
  min-height: 50px;
}
.header-btn-wrap:hover, .header-btn-wrap:focus, .header-btn-wrap:active {
  background-color: rgb(2, 58, 40) !important;
  color: #fff !important;
  border-color: rgb(2, 58, 40) !important;
}
@media (max-width: 1600px) {
  .header-btn-wrap {
    font-size: 16px;
    line-height: 24px;
    padding: 6px 12px;
    min-width: 125px;
    min-height: 42px;
  }
}
@media (max-width: 1399px) {
  .header-btn-wrap {
    font-size: 14px;
    line-height: 22px;
    padding: 4px 10px;
    min-width: 100px;
    min-height: 35px;
  }
}

.ant-modal-root .ant-modal-mask,
.ant-modal-root .ant-modal-wrap {
  z-index: 1030;
}
.ant-modal-root .common-admin-popup .ant-modal-content {
  padding: 30px 20px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-close {
  background-color: rgba(193, 10, 10, 0.15);
  width: 25px;
  height: 25px;
  color: rgb(199, 16, 38);
  display: flex;
  align-items: center;
  justify-content: center;
  top: 8px;
  right: 8px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-close .ant-modal-close-x {
  font-size: 15px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body {
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgb(233, 234, 243);
  font-family: "Manrope", "Helvetica Neue", Arial, sans-serif;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field {
  margin-bottom: 20px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  width: 100%;
  column-gap: 10px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap {
  width: 100%;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap .stepper-input-field {
  border: 1px solid rgb(219, 219, 219);
  padding: 6px 20px;
  border-radius: 10px;
  background-color: rgb(249, 249, 249);
  color: rgb(0, 64, 43);
  font-weight: 500;
  width: 100%;
  min-height: 50px;
  font-size: 16px;
  line-height: 24px;
  font-family: "Manrope", "Helvetica Neue", Arial, sans-serif;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap .stepper-input-field:hover, .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap .stepper-input-field:focus, .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap .stepper-input-field:active {
  border: 1px solid #198754;
  box-shadow: 0 0 0px 1px #198754;
  color: rgb(0, 64, 43);
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  row-gap: 10px;
  column-gap: 10px;
  margin-top: 5px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper .ant-upload .upload-btn {
  height: auto;
  padding: 10px;
  border-radius: 10px;
  border: 1px dashed rgba(1, 35, 24, 0.3);
  color: rgb(2, 58, 40);
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper .ant-upload .upload-btn img {
  width: 32px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper .uploaded-file-wrapper {
  border: 1px solid rgb(219, 219, 219);
  width: 75px;
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 6px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper .uploaded-file-wrapper img {
  border-radius: 0px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .delete-icon-wrap {
  padding: 0px;
  border: 0px;
  width: 28px;
  height: 28px;
  min-width: auto;
  min-height: auto;
  border-radius: 50%;
  background-color: rgba(238, 15, 55, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .delete-icon-wrap img {
  width: 15px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .delete-icon-wrap + .add-requirement-input-wrap {
  width: calc(100% - 38px);
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper:not(:last-child) {
  margin-bottom: 18px;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field {
  display: flex;
  justify-content: flex-end;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn {
  padding: 0px;
  border-radius: 0px;
  border: 0px;
  text-decoration: none;
  font-size: 18px;
  line-height: 24px;
  color: rgb(0, 58, 39) !important;
  font-weight: 600;
  display: flex;
  align-items: center;
  column-gap: 5px;
  min-width: auto;
  min-height: auto;
  background-color: transparent;
  box-shadow: none;
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn .add-icon {
  font-size: 24px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: rgb(186, 241, 81);
  color: rgb(0, 58, 39);
}
.ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn:hover, .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn:focus, .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn:active {
  background-color: transparent !important;
  color: rgb(0, 58, 39) !important;
  opacity: 0.6;
}
@media (max-width: 1600px) {
  .ant-modal-root .common-admin-popup {
    width: 650px !important;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn {
    font-size: 14px;
    line-height: 22px;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn .add-icon {
    font-size: 20px;
    width: 22px;
    height: 22px;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap .stepper-input-field {
    padding: 6px 16px;
    min-height: 45px;
    font-size: 15px;
    line-height: 22px;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper {
    row-gap: 10px;
    column-gap: 10px;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper .ant-upload .upload-btn {
    font-size: 13px;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .add-requirement-input-wrap.upload-flag-wrapper .uploaded-file-wrapper {
    width: 60px;
    height: 60px;
    padding: 5px;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .delete-icon-wrap {
    width: 25px;
    height: 25px;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-requirement-field .add-required-field-wrapper .delete-icon-wrap img {
    width: 13px;
  }
}
@media (max-width: 1399px) {
  .ant-modal-root .common-admin-popup {
    width: 550px !important;
  }
  .ant-modal-root .common-admin-popup .ant-modal-content .ant-modal-body .add-other-field .add-field-btn {
    font-size: 14px;
    line-height: 20px;
  }
}

.add-requirement-field label,
.add-requirement-field .common-stepper-label {
  font-size: 22px;
  line-height: 28px;
  font-weight: 600;
  color: rgb(0, 64, 43);
  margin-bottom: 6px;
  width: 100%;
}
@media (max-width: 1600px) {
  .add-requirement-field label,
  .add-requirement-field .common-stepper-label {
    font-size: 18px;
    line-height: 26px;
    margin-bottom: 4px;
  }
}
@media (max-width: 1399px) {
  .add-requirement-field label,
  .add-requirement-field .common-stepper-label {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/common.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,wCAAA;AACJ;;AAGI;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;AAAR;AACQ;EACI,YAAA;AACZ;AACQ;EACI,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACZ;AAAY;EACI,WAAA;EACA,YAAA;EACA,oBAAA;AAEhB;AADgB;EACI,WAAA;AAGpB;AAAY;EACI,aAAA;EACA,sBAAA;EACA,wBAAA;EACA,YAAA;AAEhB;AADgB;EACI,WAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AAGpB;AADgB;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;AAGpB;AAEY;EACI,gBAAA;AAAhB;AAEoB;EACI,eAAA;EACA,iBAAA;EACA,WAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AAAxB;AACwB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAC5B;AACwB;EACI,oCAAA;EACA,gBAAA;EACA,qBAAA;AAC5B;AAA4B;EACI,qBAAA;AAEhC;AAA4B;EACI,SAAA;EACA,UAAA;EACA,yBAAA;EACA,gCAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,6BAAA;EACA,gCAAA;AAEhC;AAA4B;EACI,aAAA;AAEhC;AAEoB;EACI,mBAAA;AAAxB;AAMI;EACI;IACI,gBAAA;IACA,YAAA;EAJV;EAKU;IACI,oBAAA;IACA,gBAAA;EAHd;EAIc;IACI,WAAA;IACA,YAAA;EAFlB;EAIc;IACI,wBAAA;EAFlB;EAGkB;IACI,eAAA;EADtB;EAGkB;IACI,eAAA;IACA,iBAAA;EADtB;EAKU;IACI,YAAA;EAHd;EAIc;IACI,gBAAA;EAFlB;EAIsB;IACI,eAAA;IACA,iBAAA;IACA,kBAAA;EAF1B;EAG0B;IACI,iBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EAD9B;EAI8B;IACI,yBAAA;IACA,UAAA;EAFlC;AACF;AAUI;EACI;IACI,gBAAA;IACA,YAAA;EARV;EASU;IACI,oBAAA;IACA,eAAA;EAPd;EAQc;IACI,WAAA;IACA,YAAA;EANlB;EAQc;IACI,wBAAA;IACA,YAAA;EANlB;EAOkB;IACI,eAAA;EALtB;EAOkB;IACI,eAAA;IACA,iBAAA;EALtB;EASU;IACI,YAAA;EAPd;EAQc;IACI,gBAAA;EANlB;EAQsB;IACI,eAAA;IACA,iBAAA;IACA,iBAAA;EAN1B;EAO0B;IACI,iBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EAL9B;EAQ8B;IACI,yBAAA;EANlC;AACF;;AAiBI;EACI,oCAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;AAdR;AAeQ;EACI,yBAAA;AAbZ;AAcY;EACI,iBAAA;EACA,oBAAA;AAZhB;AAagB;EACI,gBAAA;EACA,kBAAA;AAXpB;AAYoB;EACI,0CAAA;AAVxB;AAYoB;EACI,yCAAA;AAVxB;AAYoB;EACI,2CAAA;AAVxB;AAYoB;EACI,2CAAA;AAVxB;AAYoB;EACI,wCAAA;AAVxB;AAYoB;EACI,oCAAA;AAVxB;AAYoB;EACI,oCAAA;AAVxB;AAYoB;EACI,yCAAA;AAVxB;AAYoB;EACI,0CAAA;AAVxB;AAYoB;EACI,kBAAA;AAVxB;AAWwB;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAT5B;AAU4B;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,0BAAA;AARhC;AAU4B;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AARhC;AASgC;EACI,yCAAA;EACA,sBAAA;AAPpC;AASgC;EACI,yCAAA;EACA,uBAAA;AAPpC;AAWwB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,QAAA;AAT5B;AAU4B;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AARhC;AAU4B;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;AARhC;AAU4B;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AARhC;AAgBI;EACI;IACI,yBAAA;EAdV;EAgBc;IACI,iBAAA;IACA,oBAAA;EAdlB;EAgBsB;IACI,kBAAA;EAd1B;EAe0B;IACI,mBAAA;EAb9B;EAc8B;IACI,eAAA;IACA,iBAAA;EAZlC;EAgB8B;IACI,eAAA;IACA,iBAAA;EAdlC;AACF;AAsBI;EACI;IACI,yBAAA;EApBV;EAsBc;IACI,gBAAA;IACA,oBAAA;EApBlB;EAsBsB;IACI,aAAA;EApB1B;EAqB0B;IACI,kBAAA;EAnB9B;EAoB8B;IACI,eAAA;IACA,iBAAA;EAlBlC;EAqB0B;IACI,QAAA;EAnB9B;EAoB8B;IACI,eAAA;IACA,iBAAA;EAlBlC;EAoB8B;IACI,eAAA;IACA,iBAAA;EAlBlC;AACF;;AA4BA;EACI,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAzBJ;AA0BI;EACI,+BAAA;EACA,6BAAA;AAxBR;AA4BoB;;EAEI,qBAAA;EACA,2DAAA;EACA,2CAAA;AA1BxB;AA4BoB;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AA1BxB;AA2BwB;EACI,aAAA;AAzB5B;AA4BoB;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA1BxB;AA2BwB;EACI,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,wBAAA;AAzB5B;AA0B4B;EACI,gBAAA;EACA,0BAAA;EACA,eAAA;AAxBhC;AA2BwB;EACI,WAAA;EACA,cAAA;AAzB5B;AA2BwB;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AAzB5B;AA+BwB;EACI,6BAAA;AA7B5B;AA8B4B;EACI,+BAAA;AA5BhC;AA8B4B;EACI,6BAAA;AA5BhC;AAmCwB;EACI,kBAAA;AAjC5B;AA4C4B;EACI,iBAAA;AA1ChC;AA8C4B;EACI,iBAAA;AA5ChC;AA0D4B;EACI,iBAAA;AAxDhC;AAkEY;EACI,WAAA;AAhEhB;AAiEgB;EACI,YAAA;AA/DpB;AAyEwB;EACI,2CAAA;AAvE5B;AAmFwB;EACI,wCAAA;AAjF5B;AA6FwB;EACI,yCAAA;AA3F5B;AAkGI;EAjKJ;IAkKQ,aAAA;EA/FN;EAsG8B;IACI,eAAA;EApGlC;AACF;AA4GI;EAKoB;IACI,iBAAA;IACA,eAAA;IACA,iBAAA;EA9G1B;EAgHsB;IACI,eAAA;IACA,iBAAA;EA9G1B;EAgH8B;IACI,eAAA;EA9GlC;AACF;;AAwHA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AArHJ;;AAwHA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AArHJ;AAsHI;EACI,cAAA;EACA,YAAA;EACA,mBAAA;AApHR;AAsHI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AApHR;AAqHQ;EACI,kBAAA;AAnHZ;AAsHI;EACI,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,oCAAA;AApHR;AAqHQ;EACI,oCAAA;AAnHZ;AAsHI;EACI;IACI,WAAA;IACA,YAAA;EApHV;AACF;AAsHI;EACI;IACI,WAAA;IACA,YAAA;EApHV;AACF;;AAwHA;EACI,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;AArHJ;AAuHI;EACI,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,mCAAA;EACA,WAAA;AArHR;AAsHQ;EACI,qDAAA;EACA,yBAAA;AApHZ;;AAyHA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAtHJ;AAuHI;EAEI,yCAAA;EACA,sBAAA;AAtHR;AAwHI;EACI,0CAAA;EACA,wBAAA;AAtHR;AAwHI;EACI,yCAAA;EACA,kCAAA;AAtHR;AAwHI;EACI,gCAAA;EACA,WAAA;AAtHR;AAwHI;EACI,yCAAA;EACA,uBAAA;AAtHR;AAwHI;EACI,YAAA;AAtHR;AAwHI;EAhCJ;IAiCQ,WAAA;IACA,YAAA;IACA,eAAA;EArHN;AACF;AAsHI;EArCJ;IAsCQ,WAAA;IACA,YAAA;IACA,eAAA;EAnHN;AACF;;AAsHA;EACI,2DAAA;AAnHJ;AAoHI;EACI,mBAAA;AAlHR;AAmHQ;EACI,aAAA;AAjHZ;AAoHY;EACI,gBAAA;AAlHhB;AAmHgB;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,mBAAA;AAjHpB;AAkHoB;EACI,WAAA;AAhHxB;AAkHoB;EACI,kBAAA;EACA,gBAAA;AAhHxB;AAiHwB;EACI,cAAA;AA/G5B;AAkHoB;EACI,yBAAA;AAhHxB;AAiHwB;EACI,cAAA;AA/G5B;AAsHI;EACI;IACI,mBAAA;EApHV;EAuHkB;IACI,eAAA;IACA,iBAAA;EArHtB;EAsHsB;IACI,iBAAA;EApH1B;AACF;AA2HI;EACI;IACI,mBAAA;EAzHV;EA4HkB;IACI,eAAA;IACA,iBAAA;EA1HtB;EA2HsB;IACI,iBAAA;EAzH1B;AACF;;AAiIA;EACI,2DAAA;AA9HJ;AAiIY;EACI,yCAAA;EACA,kCAAA;AA/HhB;AAiIY;EACI,gCAAA;AA/HhB;;AAsII;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAnIR;AAqII;EACI,2CAAA;EACA,yBAAA;EACA,sCAAA;AAnIR;AAqII;EACI,2CAAA;EACA,yBAAA;EACA,0CAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAnIR;AAqII;EACI,yBAAA;AAnIR;AAsIQ;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AApIZ;;AAyIA;EACI,eAAA;EACA,iBAAA;EACA,2DAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AAtIJ;AAuII;EAPJ;IAQQ,eAAA;IACA,iBAAA;IACA,mBAAA;EApIN;AACF;AAqII;EAZJ;IAaQ,eAAA;IACA,iBAAA;IACA,mBAAA;EAlIN;AACF;;AAqIA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAlIJ;;AAsII;EACI,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAnIR;AAqII;EARJ;IASQ,gBAAA;IACA,gBAAA;EAlIN;AACF;AAmII;EAZJ;IAaQ,gBAAA;IACA,eAAA;EAhIN;AACF;;AAmIA;;EAEI,2DAAA;AAhIJ;AAiII;;;EAEI,8BAAA;EACA,uBAAA;AA9HR;AA+HQ;;;;;EAEI,yCAAA;EACA,6CAAA;EACA,sBAAA;AA1HZ;AA6HI;;;EAEI,gCAAA;EACA,WAAA;EACA,4BAAA;AA1HR;AA2HQ;;;;;EAEI,uCAAA;EACA,iCAAA;EACA,gCAAA;AAtHZ;AAyHI;EA1BJ;;IA2BQ,eAAA;IACA,iBAAA;EArHN;AACF;AAsHI;EA9BJ;;IA+BQ,eAAA;IACA,iBAAA;EAlHN;AACF;;AAsHA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAnHJ;AAoHI;EACI,kBAAA;AAlHR;;AAsHA;EACI,oCAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAnHJ;AAoHI;EAGI,2CAAA;EACA,sBAAA;EACA,uCAAA;AApHR;AAsHI;EAjBJ;IAkBQ,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAnHN;AACF;AAqHI;EAzBJ;IA0BQ,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,gBAAA;IACA,gBAAA;EAlHN;AACF;;AAsHI;;EAEI,aAAA;AAnHR;AAsHQ;EACI,kBAAA;AApHZ;AAqHY;EACI,yCAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;AAnHhB;AAoHgB;EACI,eAAA;AAlHpB;AAqHY;EACI,oBAAA;EACA,mBAAA;EACA,2CAAA;EACA,2DAAA;AAnHhB;AAoHgB;EACI,mBAAA;AAlHpB;AAmHoB;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;AAjHxB;AAkHwB;EACI,WAAA;AAhH5B;AAiH4B;EACI,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,2DAAA;AA/GhC;AAgHgC;EAGI,yBAAA;EACA,+BAAA;EACA,qBAAA;AAhHpC;AAmH4B;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAjHhC;AAmHoC;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAjHxC;AAkHwC;EACI,WAAA;AAhH5C;AAoHgC;EACI,oCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAlHpC;AAmHoC;EACI,kBAAA;AAjHxC;AAsHwB;EACI,YAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApH5B;AAqH4B;EACI,WAAA;AAnHhC;AAqH4B;EACI,wBAAA;AAnHhC;AAsHwB;EACI,mBAAA;AApH5B;AAwHgB;EACI,aAAA;EACA,yBAAA;AAtHpB;AAuHoB;EACI,YAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AArHxB;AAsHwB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mCAAA;EACA,qBAAA;AApH5B;AAsHwB;EAGI,wCAAA;EACA,gCAAA;EACA,YAAA;AAtH5B;AA4HQ;EA1JJ;IA2JQ,uBAAA;EAzHV;EA6HsB;IACI,eAAA;IACA,iBAAA;EA3H1B;EA4H0B;IACI,eAAA;IACA,WAAA;IACA,YAAA;EA1H9B;EAiI8B;IACI,iBAAA;IACA,gBAAA;IACA,eAAA;IACA,iBAAA;EA/HlC;EAiI8B;IACI,aAAA;IACA,gBAAA;EA/HlC;EAiIsC;IACI,eAAA;EA/H1C;EAkIkC;IACI,WAAA;IACA,YAAA;IACA,YAAA;EAhItC;EAoI0B;IACI,WAAA;IACA,YAAA;EAlI9B;EAmI8B;IACI,WAAA;EAjIlC;AACF;AAwIQ;EA7MJ;IA8MQ,uBAAA;EArIV;EAyIsB;IACI,eAAA;IACA,iBAAA;EAvI1B;AACF;;AAgJI;;EAEI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;AA7IR;AA+II;EACI;;IAEI,eAAA;IACA,iBAAA;IACA,kBAAA;EA7IV;AACF;AA+II;EACI;;IAEI,eAAA;IACA,iBAAA;IACA,kBAAA;EA7IV;AACF","sourcesContent":[".ant-table-row > .custom-table-row {\n    padding: 16px 24px;\n    /* Modify the padding values as needed */\n}\n\n.sidebar{\n    &.admin-sidebar{\n        border-right: 0px;\n        width: 300px;\n        margin-top: 90px;\n        .sidebar-wrapper{\n            width: 300px;\n        }\n        .sidebar-user-details{\n            position: relative;\n            z-index: 4;\n            padding: 30px 25px 0;\n            display: flex;\n            align-items: center;\n            column-gap: 15px;\n            .user-img-wrap{\n                width: 65px;\n                height: 65px;\n                display: inline-flex;\n                img{\n                    width: 100%;\n                }\n            }\n            .sidebar-logged-user{\n                display: flex;\n                flex-direction: column;\n                width: calc(100% - 80px);\n                row-gap: 4px;\n                .logged-user-name{\n                    color: #fff;\n                    font-size: 20px;\n                    line-height: 1;\n                    margin: 0px;\n                }\n                .logged-user-pack{\n                    color: rgba(164, 164, 164, 1);\n                    font-size: 16px;\n                    line-height: 23px;\n                }\n            }\n        }\n        .sidebar-wrapper{\n            .nav{\n                margin-top: 30px;\n                li{\n                    .nav-NavLink{\n                        font-size: 18px;\n                        line-height: 30px;\n                        color: #fff;\n                        text-transform: capitalize;\n                        display: flex;\n                        align-items: center;\n                        padding: 12px 20px;\n                        margin: 0px;\n                        font-weight: 500;\n                        opacity: 1;\n                        i{\n                            margin-right: 8px;\n                            width: 30px;\n                            height: 30px;\n                            justify-content: center;\n                            display: flex;\n                            align-items: center;\n                            color: #fff;\n                        }\n                        &.active{\n                            background-color: rgba(255, 255, 255, 1);\n                            font-weight: 600;\n                            color: rgba(2, 58, 40, 1);\n                            i{\n                                color: rgba(2, 58, 40, 1);\n                            }\n                            &:before{\n                                left: 0px;\n                                width: 6px;\n                                height: calc(100% - 20px);\n                                background-color: rgba(2, 58, 40, 1);\n                                border: 0px;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                border-top-right-radius: 10px;\n                                border-bottom-right-radius: 10px;\n                            }\n                            &:after{\n                                display: none;\n                            }\n                        }\n                    }\n                    &:not(:last-child){\n                        margin-bottom: 10px\n                    }\n                }\n            }\n        }\n    }\n    @media (max-width:1600px) {\n        &.admin-sidebar{\n            margin-top: 72px;\n            width: 280px;\n            .sidebar-user-details{\n                padding: 25px 20px 0;\n                column-gap: 10px;\n                .user-img-wrap{\n                    width: 50px;\n                    height: 50px;\n                }\n                .sidebar-logged-user{\n                    width: calc(100% - 60px);\n                    .logged-user-name{\n                        font-size: 18px;\n                    }\n                    .logged-user-pack{\n                        font-size: 15px;\n                        line-height: 20px;\n                    }\n                }\n            }\n            .sidebar-wrapper{\n                width: 280px;\n                .nav{\n                    margin-top: 20px;\n                    li {\n                        .nav-NavLink{\n                            font-size: 17px;\n                            line-height: 26px;\n                            padding: 10px 15px;\n                            i{\n                                margin-right: 6px;\n                                width: 26px;\n                                height: 26px;\n                                font-size: 18px;\n                            }\n                            &.active{\n                                &:before{\n                                    height: calc(100% - 18px);\n                                    width: 5px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @media (max-width:1399px) {\n        &.admin-sidebar{\n            margin-top: 55px;\n            width: 240px;\n            .sidebar-user-details{\n                padding: 20px 15px 0;\n                column-gap: 8px;\n                .user-img-wrap{\n                    width: 40px;\n                    height: 40px;\n                }\n                .sidebar-logged-user{\n                    width: calc(100% - 45px);\n                    row-gap: 2px;\n                    .logged-user-name{\n                        font-size: 16px;\n                    }\n                    .logged-user-pack{\n                        font-size: 13px;\n                        line-height: 18px;\n                    }\n                }\n            }\n            .sidebar-wrapper{\n                width: 240px;\n                .nav{\n                    margin-top: 15px;\n                    li {\n                        .nav-NavLink{\n                            font-size: 15px;\n                            line-height: 24px;\n                            padding: 8px 10px;\n                            i{\n                                margin-right: 4px;\n                                width: 24px;\n                                height: 24px;\n                                font-size: 16px;\n                            }\n                            &.active{\n                                &:before{\n                                    height: calc(100% - 14px);\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.main-panel{\n    &.admin-main-body{\n        background-color: rgba(250, 250, 250, 1);\n        width: calc(100% - 300px);\n        height: 100vh;\n        overflow: hidden;\n        .admin-panel-content{\n            height: calc(100vh - 0px);\n            .content{\n                margin-top: 140px;\n                padding: 0 40px 30px;\n                .dashboard-cards{\n                    box-shadow: none;\n                    border-radius: 8px;\n                    &.bg-light-yellow{\n                        background-color: rgba(255, 167, 85, 0.21);\n                    }\n                    &.bg-light-purple{\n                        background-color: rgba(81, 40, 167, 0.21);\n                    }\n                    &.bg-light-cyan{\n                        background-color: rgba(112, 159, 186, 0.21);\n                    }\n                    &.bg-light-pink{\n                        background-color: rgba(228, 186, 243, 0.21);\n                    }\n                    &.bg-light-green{\n                        background-color: rgba(11, 138, 0, 0.12);\n                    }\n                    &.bg-dark-green{\n                        background-color: rgba(216, 238, 174, 1);\n                    }\n                    &.bg-green{\n                        background-color: rgba(191, 221, 211, 1);\n                    }\n                    &.bg-light-red{\n                        background-color: rgba(255, 77, 79, 0.21);\n                    }\n                    &.bg-light-blue{\n                        background-color: rgba(22, 119, 255, 0.21);\n                    }\n                    .card-body{\n                        padding: 20px 30px;\n                        .card-head-wrap{\n                            display: flex;\n                            align-items: center;\n                            column-gap: 12px;\n                            margin-bottom: 12px;\n                            .card-title{\n                                font-size: 21px;\n                                line-height: 28px;\n                                font-weight: 500;\n                                color: rgba(52, 52, 52, 1);\n                                margin: 0px;\n                                text-transform: capitalize;\n                            }\n                            .card-badge{\n                                padding: 4px 5px;\n                                border-radius: 66px;\n                                font-size: 16px;\n                                line-height: 24px;\n                                display: flex;\n                                align-items: center;\n                                column-gap: 4px;\n                                &.green-badge{\n                                    background-color: rgba(35, 193, 10, 0.15);\n                                    color: rgba(11, 138, 0, 1);\n                                }\n                                &.red-badge{\n                                    background-color: rgba(193, 10, 10, 0.15);\n                                    color: rgba(199, 16, 38, 1);\n                                }\n                            }\n                        }\n                        .card-foot-details{\n                            display: flex;\n                            flex-direction: row;\n                            flex-wrap: wrap;\n                            align-items: flex-end;\n                            gap: 5px;\n                            .total-figure{\n                                margin: 0px;\n                                font-weight: 600;\n                                font-size: 32px;\n                                line-height: 44px;\n                                color: rgba(35, 35, 35, 1);\n                                margin-bottom: 0px;\n                            }\n                            .card-label{\n                                font-size: 16px;\n                                line-height: 24px;\n                                color: rgba(148, 148, 148, 1);\n                            }\n                            .card-click-link{\n                                margin-left: auto;\n                                font-size: 13px;\n                                line-height: 18px;\n                                font-weight: 600;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @media (max-width:1600px) {\n        &.admin-main-body{\n            width: calc(100% - 280px);\n            .admin-panel-content{\n                .content{\n                    margin-top: 120px;\n                    padding: 0 30px 25px;\n                    .dashboard-cards {\n                        .card-body{\n                            padding: 15px 25px;\n                            .card-head-wrap {\n                                margin-bottom: 10px;\n                                .card-title{\n                                    font-size: 18px;\n                                    line-height: 26px;\n                                }\n                            }\n                            .card-foot-details {\n                                .total-figure{\n                                    font-size: 28px;\n                                    line-height: 40px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @media (max-width:1399px) {\n        &.admin-main-body{\n            width: calc(100% - 240px);\n            .admin-panel-content{\n                .content{\n                    margin-top: 85px;\n                    padding: 0 25px 20px;\n                    .dashboard-cards {\n                        .card-body{\n                            padding: 10px;\n                            .card-head-wrap {\n                                margin-bottom: 6px;\n                                .card-title{\n                                    font-size: 16px;\n                                    line-height: 24px;\n                                }\n                            }\n                            .card-foot-details {\n                                gap: 2px;\n                                .total-figure{\n                                    font-size: 20px;\n                                    line-height: 28px;\n                                }\n                                .card-click-link{\n                                    font-size: 12px;\n                                    line-height: 16px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.ant-table-wrapper{\n    border: 1px solid rgba(203, 203, 203, 1);\n    border-radius: 14px;\n    color: rgba(2, 58, 40, 1);\n    padding: 15px;\n    background-color: #fff;\n    height: 100%;\n    .ant-table{\n        border-start-start-radius: 14px;\n        border-start-end-radius: 14px;\n        .ant-table-container{\n            table{\n                tr{\n                    th,\n                    td{\n                        color: rgba(2, 58, 40, 1);\n                        font-family: \"Manrope\", \"Helvetica Neue\", Arial, sans-serif;\n                        border-bottom: 1px solid rgba(239, 239, 239, 1);\n                    }\n                    th{\n                        padding: 12px 8px;\n                        font-size: 15px;\n                        line-height: 24px;\n                        font-weight: 500;\n                        white-space: nowrap;\n                        &:before{\n                            display: none;\n                        }\n                    }\n                    td{\n                        padding: 10px 8px;\n                        font-size: 14px;\n                        line-height: 22px;\n                        font-weight: 400;\n                        h6{\n                            font-weight: 400;\n                            text-transform: capitalize;\n                            margin: 0 0 7px 0;\n                            width: calc(100% - 55px);\n                            &.request-name{\n                                font-weight: 600;\n                                text-transform: capitalize;\n                                font-size: 16px;\n                            }\n                        }\n                        p{\n                            margin: 0px;\n                            line-height: 1;\n                        }\n                        .cmn-user-detail{\n                            display: flex;\n                            align-items: center;\n                            column-gap: 20px;\n                        }\n                    }\n                }\n                .ant-table-thead{\n                    tr{\n                        th{\n                            background-color: transparent;\n                            &:first-child{\n                                border-start-start-radius: 14px;\n                            }\n                            &:last-child{\n                                border-start-end-radius: 14px;\n                            }\n                        }\n                    }\n                }\n                .ant-table-tbody{\n                    .ant-table-placeholder{\n                        .ant-table-cell{\n                            border-bottom: 0px;\n                        }\n                    }\n                }\n            }\n        }\n        &.ant-table-fixed-header{\n            .ant-table-container{\n                table{\n                    tr{\n                        th{\n                            &:nth-last-child(2){\n                                text-align: right;\n                            }\n                        }\n                        td{\n                            &:last-child{\n                                text-align: right;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.ltd-column-table{\n        .ant-table{\n            .ant-table-container{\n                table{\n                    tr{\n                        th{\n                            &:last-child{\n                                text-align: right;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .ant-table-empty{\n        .ant-table-tbody{\n            .ant-table-placeholder{\n                width: 100%;\n                td{\n                    padding: 0px;\n                }\n            }\n        }\n    }\n    &.requested-shifts{\n        .ant-table{\n            .ant-table-container table {\n                .ant-table-thead {\n                    tr {\n                        th{\n                            background-color: rgba(228, 186, 243, 0.21);\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.accepted-shifts{\n        .ant-table{\n            .ant-table-container table {\n                .ant-table-thead {\n                    tr {\n                        th{\n                            background-color: rgba(11, 138, 0, 0.12);\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.declined-shifts{\n        .ant-table{\n            .ant-table-container table {\n                .ant-table-thead {\n                    tr {\n                        th{\n                            background-color: rgba(255, 77, 79, 0.21);\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @media (max-width:1600px){\n        padding: 10px;\n        .ant-table {\n            .ant-table-container {\n                table {\n                    tr {\n                        td {\n                            h6{\n                                &.request-name{\n                                    font-size: 14px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @media (max-width:1399px){\n        .ant-table {\n            .ant-table-container {\n                table {\n                    tr {\n                        th{\n                            padding: 10px 8px;\n                            font-size: 14px;\n                            line-height: 22px;\n                        }\n                        td{\n                            font-size: 13px;\n                            line-height: 20px;\n                            h6{\n                                &.request-name{\n                                    font-size: 13px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.fields-wrapper{\n    display: flex;\n    flex-direction: column;\n    row-gap: 8px;\n}\n\n.tbl-user-details{\n    display: flex;\n    align-items: center;\n    column-gap: 15px;\n    overflow: hidden;\n    *{\n        flex-shrink: 1;\n        flex-grow: 1;\n        white-space: nowrap;\n    }\n    .ant-avatar{\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n        flex-shrink: 0;\n        flex-grow: 0;\n        img{\n            border-radius: 50%;\n        }\n    }\n    &:hover{\n        overflow: visible;\n        position: relative;\n        z-index: 2;\n        background: rgb(255, 255, 255, 0.6);\n        *{\n            background: rgb(255, 255, 255, 0.6);\n        }\n    }\n    @media (max-width:1600px){\n        .ant-avatar{\n            width: 36px;\n            height: 36px;\n        }\n    }\n    @media (max-width:1399px){\n        .ant-avatar{\n            width: 32px;\n            height: 32px;\n        }\n    }\n}\n\n.action-btn{\n    border: 0px;\n    padding: 0;\n    border-radius: 50%;\n    box-shadow: none;\n    background-color: transparent;\n    \n    &.action-approve-user{\n        width: auto;\n        padding: 6px 10px;\n        border-radius: 30px;\n        background-color: rgb(52, 152, 219);\n        color: #fff;\n        &:hover{\n            background-color: rgba(52, 152, 219, 0.15) !important;\n            color: inherit !important;\n        }\n    }\n}\n\n.fas{\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    font-size: 13px;\n    &.fa-edit,\n    &.fa-eye{\n        background-color: rgba(35, 193, 10, 0.15);\n        color: rgb(11, 138, 0);\n    }\n    &.fa-sign-in-alt{\n        background-color: rgba(52, 152, 219, 0.15);\n        color: rgb(52, 152, 219);\n    }\n    &.fa-trash-alt{\n        background-color: rgba(193, 10, 10, 0.15);\n        color: rgb(199, 16, 38) !important;\n    }\n    &.fa-check{\n        background-color: rgba(2, 58, 40, 1);\n        color: #fff;\n    }\n    &.fa-times{\n        background-color: rgba(193, 10, 10, 0.15);\n        color: rgb(199, 16, 38);\n    }\n    &:hover{\n        opacity: 0.7;\n    }\n    @media (max-width:1600px){\n        width: 24px;\n        height: 24px;\n        font-size: 12px;\n    }\n    @media (max-width:1399px){\n        width: 22px;\n        height: 22px;\n        font-size: 10px;\n    }\n}\n\n.antd-tabs-wrapper{\n    font-family: \"Manrope\", \"Helvetica Neue\", Arial, sans-serif;\n    .ant-tabs-nav{\n        margin-bottom: 40px;\n        &:before{\n            display: none;\n        }\n        .ant-tabs-nav-wrap{\n            .ant-tabs-nav-list{\n                column-gap: 10px;\n                .ant-tabs-tab{\n                    padding: 0px;\n                    border: 0px;\n                    font-size: 20px;\n                    line-height: 28px;\n                    color: #99A7A3;\n                    background-color: transparent;\n                    border-radius: 60px;\n                    &+.ant-tabs-tab{\n                        margin: 0px;\n                    }\n                    .ant-tabs-tab-btn{\n                        padding: 10px 18px;\n                        font-weight: 600;\n                        &:focus{\n                            color: #99A7A3;\n                        }\n                    }\n                    &.ant-tabs-tab-active{\n                        background-color: #023A28;\n                        .ant-tabs-tab-btn{\n                            color: #FFFFFF;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    @media (max-width: 1600px){\n        .ant-tabs-nav{\n            margin-bottom: 30px;\n            .ant-tabs-nav-wrap{\n                .ant-tabs-nav-list{\n                    .ant-tabs-tab{\n                        font-size: 18px;\n                        line-height: 26px;\n                        .ant-tabs-tab-btn{\n                            padding: 8px 14px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    @media (max-width: 1399px){\n        .ant-tabs-nav{\n            margin-bottom: 20px;\n            .ant-tabs-nav-wrap{\n                .ant-tabs-nav-list{\n                    .ant-tabs-tab{\n                        font-size: 16px;\n                        line-height: 24px;\n                        .ant-tabs-tab-btn{\n                            padding: 6px 14px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.ant-popover-content{\n    font-family: \"Manrope\", \"Helvetica Neue\", Arial, sans-serif;\n    .ant-popover-inner-content{\n        .ant-popconfirm-buttons{\n            .ant-btn-default{\n                border-color: rgb(199, 16, 38) !important;\n                color: rgb(199, 16, 38) !important;\n            }\n            .ant-btn-primary{\n                background-color: rgb(2, 58, 40);\n            }\n        }\n    }\n}\n\n.card{\n    .card-sub-title{\n        color: rgb(2, 58, 40);\n        font-size: 16px;\n        line-height: 24px;\n        font-weight: 500;\n    }\n    .input-value[disabled]{\n        background-color: rgba(112, 112, 112, 0.15);\n        color: rgb(112, 112, 112);\n        border-color: rgba(112, 112, 112, 0.5);\n    }\n    .static-value{\n        background-color: rgba(112, 112, 112, 0.15);\n        color: rgb(112, 112, 112);\n        border: 1px solid rgba(112, 112, 112, 0.5);\n        width: 100%;\n        display: flex;\n        padding: 10px;\n        border-radius: 4px;\n        font-size: 14px;\n        line-height: normal;\n    }\n    .form-group{\n        color: rgb(112, 112, 112);\n    }\n    .card-sec{\n        .card-sec-title{\n            color: rgb(2, 58, 40);\n            font-size: 20px;\n            line-height: 28px;\n            font-weight: 600;\n        }\n    }\n}\n\n.page-main-title{\n    font-size: 28px;\n    line-height: 36px;\n    font-family: \"Manrope\", \"Helvetica Neue\", Arial, sans-serif;\n    color: rgba(2, 58, 40, 1);\n    font-weight: 600;\n    margin-bottom: 20px;\n    @media (max-width:1600px){\n        font-size: 26px;\n        line-height: 32px;\n        margin-bottom: 15px;\n    }\n    @media (max-width:1399px){\n        font-size: 24px;\n        line-height: 30px;\n        margin-bottom: 10px;\n    }\n}\n\n.footer-btn-wrap{\n    margin-top: 30px;\n    display: flex;\n    align-items: center;\n    column-gap: 10px;\n}\n\n.common-footer-btn{\n    &.ant-btn{\n        padding: 4px 12px;\n        font-size: 16px;\n        line-height: 24px;\n        min-height: 40px;\n        min-width: 110px;\n    }\n    @media (max-width:1600px){\n        min-height: 36px;\n        min-width: 100px;\n    }\n    @media (max-width:1399px){\n        min-height: 32px;\n        min-width: 90px;\n    }\n}\n\n.ant-modal-footer,\n.ant-btn{\n    font-family: \"Manrope\", \"Helvetica Neue\", Arial, sans-serif;\n    .ant-btn-default,\n    &.cancel-btn-wrap{\n        border-color: rgb(199, 16, 38);\n        color: rgb(199, 16, 38);\n        &:hover,\n        &:focus{\n            border-color: rgb(199, 16, 38) !important;\n            background-color: rgb(199, 16, 38) !important;\n            color: #fff !important;\n        }\n    }\n    .ant-btn-primary,\n    &.save-btn-wrap{\n        background-color: rgb(2, 58, 40);\n        color: #fff;\n        border-color: rgb(2, 58, 40);\n        &:hover,\n        &:focus{\n            border-color: rgb(2, 58, 40) !important;\n            background-color: #fff !important;\n            color: rgb(2, 58, 40) !important;\n        }\n    }\n    @media (max-width:1600px){\n        font-size: 15px;\n        line-height: 22px;\n    }\n    @media (max-width:1399px){\n        font-size: 14px;\n        line-height: 20px;\n    }\n}\n\n\n.page-header-wrap{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    .page-main-title{\n        margin-bottom: 0px;\n    }\n}\n\n.header-btn-wrap{\n    border: 1px solid rgba(203, 203, 203, 1);\n    color: rgba(2, 58, 40, 1);\n    font-size: 18px;\n    line-height: 26px;\n    padding: 8px 14px;\n    border-radius: 30px;\n    background-color: #fff;\n    min-width: 140px;\n    min-height: 50px;\n    &:hover,\n    &:focus,\n    &:active{\n        background-color: rgba(2, 58, 40, 1) !important;\n        color: #fff !important;\n        border-color: rgba(2, 58, 40, 1) !important;\n    }\n    @media (max-width: 1600px){\n        font-size: 16px;\n        line-height: 24px;\n        padding: 6px 12px;\n        min-width: 125px;\n        min-height: 42px;\n    }\n\n    @media (max-width: 1399px){\n        font-size: 14px;\n        line-height: 22px;\n        padding: 4px 10px;\n        min-width: 100px;\n        min-height: 35px;\n    }\n}\n\n.ant-modal-root{\n    .ant-modal-mask,\n    .ant-modal-wrap{\n        z-index: 1030;\n    }\n    .common-admin-popup{\n        .ant-modal-content{\n            padding: 30px 20px;\n            .ant-modal-close{\n                background-color: rgba(193, 10, 10, 0.15);\n                width: 25px;\n                height: 25px;\n                color: rgb(199, 16, 38);\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                top: 8px;\n                right: 8px;\n                .ant-modal-close-x{\n                    font-size: 15px;\n                }\n            }\n            .ant-modal-body{\n                padding-bottom: 20px;\n                margin-bottom: 20px;\n                border-bottom: 1px solid rgb(233, 234, 243);\n                font-family: \"Manrope\", \"Helvetica Neue\", Arial, sans-serif;\n                .add-requirement-field{\n                    margin-bottom: 20px;\n                    .add-required-field-wrapper{\n                        display: flex;\n                        align-items: center;\n                        flex-direction: row-reverse;\n                        width: 100%;\n                        column-gap: 10px;\n                        .add-requirement-input-wrap{\n                            width: 100%;\n                            .stepper-input-field{\n                                border: 1px solid rgb(219, 219, 219);\n                                padding: 6px 20px;\n                                border-radius: 10px;\n                                background-color: rgb(249, 249, 249);\n                                color: rgb(0, 64, 43);\n                                font-weight: 500;\n                                width: 100%;\n                                min-height: 50px;\n                                font-size: 16px;\n                                line-height: 24px;\n                                font-family: \"Manrope\", \"Helvetica Neue\", Arial, sans-serif;\n                                &:hover,\n                                &:focus,\n                                &:active{\n                                    border: 1px solid #198754;\n                                    box-shadow: 0 0 0px 1px #198754;\n                                    color: rgb(0, 64, 43);\n                                }\n                            }\n                            &.upload-flag-wrapper{\n                                display: flex;\n                                align-items: flex-start;\n                                flex-direction: row;\n                                row-gap: 10px;\n                                column-gap: 10px;\n                                margin-top: 5px;\n                                .ant-upload{\n                                    .upload-btn{\n                                        height: auto;\n                                        padding: 10px;\n                                        border-radius: 10px;\n                                        border: 1px dashed rgba(1, 35, 24, 0.3);\n                                        color: rgba(2, 58, 40, 1);\n                                        font-size: 14px;\n                                        line-height: 22px;\n                                        font-weight: 600;\n                                        img{\n                                            width: 32px;\n                                        }\n                                    }\n                                }\n                                .uploaded-file-wrapper{\n                                    border: 1px solid rgb(219, 219, 219);\n                                    width: 75px;\n                                    height: 75px;\n                                    display: flex;\n                                    align-items: center;\n                                    justify-content: center;\n                                    padding: 8px;\n                                    border-radius: 6px;\n                                    img{\n                                        border-radius: 0px;\n                                    }\n                                }\n                            }\n                        }\n                        .delete-icon-wrap{\n                            padding: 0px;\n                            border: 0px;\n                            width: 28px;\n                            height: 28px;\n                            min-width: auto;\n                            min-height: auto;\n                            border-radius: 50%;\n                            background-color: rgba(238, 15, 55, 0.2);\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            img{\n                                width: 15px;\n                            }\n                            &+.add-requirement-input-wrap{\n                                width: calc(100% - 38px);\n                            }\n                        }\n                        &:not(:last-child){\n                            margin-bottom: 18px;\n                        }\n                    }\n                }\n                .add-other-field{\n                    display: flex;\n                    justify-content: flex-end;\n                    .add-field-btn{\n                        padding: 0px;\n                        border-radius: 0px;\n                        border: 0px;\n                        text-decoration: none;\n                        font-size: 18px;\n                        line-height: 24px;\n                        color: rgba(0, 58, 39, 1) !important;\n                        font-weight: 600;\n                        display: flex;\n                        align-items: center;\n                        column-gap: 5px;\n                        min-width: auto;\n                        min-height: auto;\n                        background-color: transparent;\n                        box-shadow: none;\n                        .add-icon{\n                            font-size: 24px;\n                            width: 28px;\n                            height: 28px;\n                            display: flex;\n                            align-items: center;\n                            justify-content: center;\n                            border-radius: 50%;\n                            background-color: rgba(186, 241, 81, 1);\n                            color: rgba(0, 58, 39, 1);\n                        }\n                        &:hover,\n                        &:focus,\n                        &:active{\n                            background-color: transparent !important;\n                            color: rgba(0, 58, 39, 1) !important;\n                            opacity: 0.6;\n                        }\n                    }\n                }\n            }\n        }\n        @media (max-width:1600px){\n            width: 650px !important;\n            .ant-modal-content{\n                .ant-modal-body{\n                    .add-other-field{\n                        .add-field-btn{\n                            font-size: 14px;\n                            line-height: 22px;\n                            .add-icon{\n                                font-size: 20px;\n                                width: 22px;\n                                height: 22px;\n                            }\n                        }\n                    }\n                    .add-requirement-field {\n                        .add-required-field-wrapper {\n                            .add-requirement-input-wrap {\n                                .stepper-input-field{\n                                    padding: 6px 16px;\n                                    min-height: 45px;\n                                    font-size: 15px;\n                                    line-height: 22px;\n                                }\n                                &.upload-flag-wrapper{\n                                    row-gap: 10px;\n                                    column-gap: 10px;\n                                    .ant-upload{\n                                        .upload-btn{\n                                            font-size: 13px;\n                                        }\n                                    }\n                                    .uploaded-file-wrapper{\n                                        width: 60px;\n                                        height: 60px;\n                                        padding: 5px\n                                    }\n                                }\n                            }\n                            .delete-icon-wrap{\n                                width: 25px;\n                                height: 25px;\n                                img{\n                                    width: 13px;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        @media (max-width:1399px){\n            width: 550px !important;\n            .ant-modal-content{\n                .ant-modal-body{\n                    .add-other-field {\n                        .add-field-btn{\n                            font-size: 14px;\n                            line-height: 20px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.add-requirement-field{\n    label,\n    .common-stepper-label{\n        font-size: 22px;\n        line-height: 28px;\n        font-weight: 600;\n        color: rgba(0, 64, 43, 1);\n        margin-bottom: 6px;\n        width: 100%;\n    }\n    @media (max-width:1600px){\n        label,\n        .common-stepper-label{\n            font-size: 18px;\n            line-height: 26px;\n            margin-bottom: 4px;\n        }\n    }\n    @media (max-width: 1399px){\n        label,\n        .common-stepper-label{\n            font-size: 14px;\n            line-height: 24px;\n            margin-bottom: 2px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
